<template>
  <div class="radio-ipt">
    <b-form-radio-group
      :id="`checkbox-ipt-${id}`"
      v-model="value"
      :options="options"
      :state="state"
      :name="`checkbox-ipt-${id}`"
      @change="inputChange(value)"
      :disabled="isBusy || isDetail"
    >
      <b-form-invalid-feedback class="text-left" :state="state"
        >Campo requerido</b-form-invalid-feedback
      >
    </b-form-radio-group>
    <hr class="hr-form-ipt2" />
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    id: {
      type: Number,
      default: 0,
    },
    isBusy: {
      type: Boolean,
      default: false,
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
    answer: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      value: null,
    };
  },
  watch: {
    answer() {
      const me = this;
      if (me.answer) me.value = me.answer;
    },
  },
  computed: {
    state() {
      return Boolean(this.value);
    },
  },
  methods: {
    inputChange(value) {
      const me = this;
      me.$emit("answerQuestion", { value, id: me.id });
    },
  },
 mounted() {
    const me = this;
    if (me.answer) me.value = me.answer;
  },
};
</script>

<style lang="scss">
.radio-ipt {
  display: flex;
  justify-content: flex-start;
  align-items: start;
  flex-direction: column;
}
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border: solid 5px;
  // border-color: #007bff;
  background-color: #ffffff !important;
}

.custom-control-label {
  padding-left: 12px;
  font-family: Ubuntu !important;
  font-weight: 700 !important;
  // color: #37474F !important;
}

.custom-radio .custom-control-label::before {
  border-radius: 50%;
  width: 20px;
  height: 20px;
}

.custom-radio .custom-control-input {
  width: 2rem !important;
  height: 2rem !important;
}

.custom-radio
  .custom-control-input:disabled:checked
  ~ .custom-control-label::before {
  background-color: #ffffff;
}

.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  width: 0px;
  height: 0px;
}

.custom-control-inline {
  display: inline-flex;
  margin-right: 5rem !important;
  align-items: center !important;
}

.was-validated .custom-control-input:valid ~ .custom-control-label,
.custom-control-input.is-valid ~ .custom-control-label {
  color: #5d5fef !important;
}

.was-validated
  .custom-control-input:valid:checked
  ~ .custom-control-label::before,
.custom-control-input.is-valid:checked ~ .custom-control-label::before {
  border-color: #5d5fef;
  background-color: #5d5fef;
}

.was-validated .custom-control-input:valid ~ .custom-control-label::before,
.custom-control-input.is-valid ~ .custom-control-label::before {
  border-color: #5d5fef;
}
</style>
